import { render } from "./MyAvatar.vue?vue&type=template&id=38fc0a47&scoped=true"
import script from "./MyAvatar.vue?vue&type=script&lang=js"
export * from "./MyAvatar.vue?vue&type=script&lang=js"

import "./MyAvatar.vue?vue&type=style&index=0&id=38fc0a47&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38fc0a47"]])

export default __exports__